import React from "react";

import { upload_steps as str } from "$strings";
import { parameterize } from "../strings/util";

const { steps } = str;

const CheckIcon = () => (
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid meet"
    viewBox="215.55555555555563 194.99999999999991 230.00000000000009 212.22222222222226"
    width="12"
    height="11"
  >
    <defs>
      <path d="M445.56 185L293.33 387.22L215.56 305" id="g1RcS9Rfhf"></path>
    </defs>
    <g>
      <g>
        <use
          xlinkHref="#g1RcS9Rfhf"
          opacity="1"
          fillOpacity="0"
          stroke="#000000"
          strokeWidth="57"
          strokeOpacity="1"
        />
      </g>
    </g>
  </svg>
);

export default ({ children, completed }) => (
  <div className="UploadStep">
    <h1>{str.title}</h1>
    <p className="visually-hidden">
      {parameterize(str.screen_reader_step_count, {
        completed,
        total: steps.length,
        current_step_name: steps[completed]
      })}
    </p>
    <div className="Progress">
      <div className="Progress-track"></div>
      <ol aria-hidden="true">
        {steps.map((name, i) => (
          <li
            key={name}
            className={`step${i + 1} ${
              completed < i
                ? ""
                : completed > i
                ? "complete"
                : "active" < i
                ? ""
                : completed > i
                ? "complete"
                : "active"
            }`}
          >
            <span className="Progress-marker">
              {completed > i ? <CheckIcon /> : " "}
            </span>
            <span className="Progress-label">{name}</span>
          </li>
        ))}
      </ol>
    </div>
    <p>{children}</p>
  </div>
);
